import { useEffect, useState } from "react";
import SelectMachineField from "./SelectMachineField";
import Radio from "@mui/material/Radio";
import RadioGroup from "@mui/material/RadioGroup";
import FormControlLabel from "@mui/material/FormControlLabel";
import FormControl from "@mui/material/FormControl";
import OperationDetailsFields from "./OperationDetailsFields";

export default function PlantingForm({ cropYear, setCropYear, farm, setFarm }) {
  const [machineType, setMachineType] = useState("");
  const [fieldState, setFieldState] = useState({
    machine_id: "",
    hours_used: "",
  });

  function handleRadioInputChange(event) {
    const nextCropYear = { ...cropYear };
    nextCropYear.planting_operation.type = event.target.value;
    setCropYear(nextCropYear);
  }

  function handleAppliedFertilizer(event) {
    const nextCropYear = { ...cropYear };
    nextCropYear.planting_operation.applied_fertilizer =
      event.target.value === "true";
    setCropYear(nextCropYear);
  }

  function handleMachineChange(machineId) {
    const nextCropYear = { ...cropYear };
    nextCropYear.planting_operation.machine_id = machineId;
    setCropYear(nextCropYear);
  }

  function handleHoursChange(hoursUsed) {
    const nextCropYear = { ...cropYear };
    nextCropYear.planting_operation.hours_used = hoursUsed;
    setCropYear(nextCropYear);
  }

  function handleOperationDetailChange(field, value) {
    setCropYear((previous) => ({
      ...previous,
      planting_operation: {
        ...previous.planting_operation,
        [field]: value,
      },
    }));
  }

  useEffect(() => {
    setMachineType(
      cropYear.planting_operation.type === "STANDALONE" ? "PLANTER" : "TRACTOR"
    );
    setFieldState({
      machine_id: cropYear.planting_operation.machine_id,
      hours_used: cropYear.planting_operation.hours_used,
    });
  }, [cropYear]);

  return (
    <section className="mt-5 w-full border-b border-slate-100 pb-5 text-[#666666]">
      <h4 className="mb-2 text-[20px] font-semibold text-slate-700">Planting</h4>

      <FormControl>
        <RadioGroup
          onChange={handleRadioInputChange}
          row
          value={cropYear.planting_operation.type || ""}
          name="planting-type"
        >
          <FormControlLabel
            value="STANDALONE"
            control={<Radio color="mainOrange" />}
            label="Planter"
          />
          <FormControlLabel
            value="ATTACHMENT"
            control={<Radio color="mainOrange" />}
            label="Tractor Attachment"
          />
        </RadioGroup>
      </FormControl>

      <SelectMachineField
        fieldLabel={"Planter Machine"}
        machineType={machineType}
        fieldState={fieldState}
        farm={farm}
        setFarm={setFarm}
        handleHoursChange={handleHoursChange}
        handleMachineChange={handleMachineChange}
      />
      <OperationDetailsFields
        cropYear={cropYear.crop_year}
        operation={cropYear.planting_operation}
        onChange={handleOperationDetailChange}
        dateLabel="Planting Date"
      />

      <FormControl>
        <p className="text-[15px] font-semibold text-slate-700">
          Did you apply fertilizer at the same time?
        </p>
        <RadioGroup
          onChange={handleAppliedFertilizer}
          row
          value={String(cropYear.planting_operation.applied_fertilizer ?? false)}
          name="planting-fertilizer"
        >
          <FormControlLabel
            value={true}
            control={<Radio color="mainOrange" />}
            label="Yes"
          />
          <FormControlLabel
            value={false}
            control={<Radio color="default" />}
            label="No"
          />
        </RadioGroup>
      </FormControl>
    </section>
  );
}
